import React from 'react';

// Water-drop loader — a drop falls and ripples spread. Use inline
// (<WaterLoader label="Loading…" />) or via the global overlay.
const WaterLoader = ({ size = 72, label, light = false, className = '' }) => (
  <div className={`flex flex-col items-center justify-center gap-2 ${className}`} role="status" aria-live="polite">
    <svg width={size} height={size} viewBox="0 0 80 80" aria-hidden="true">
      <g className="wl-drop">
        <path d="M40 18 C40 18 32 28 32 33 a8 8 0 0 0 16 0 C48 28 40 18 40 18z" fill="#2EC4B6" />
      </g>
      <ellipse className="wl-ripple" cx="40" cy="62" rx="22" ry="6" fill="none" stroke="#1A6E9A" strokeWidth="2.5" />
      <ellipse className="wl-ripple wl-ripple-2" cx="40" cy="62" rx="14" ry="4" fill="none" stroke="#2EC4B6" strokeWidth="2" />
    </svg>
    {label && <span className={`text-sm font-medium ${light ? 'text-white' : 'text-brand-700'}`}>{label}</span>}
  </div>
);

export default WaterLoader;
